<template>
  <div>
    <GenericModal
      v-if="!showSurveyModal"
      :title="modalTitle"
      :content="modalContent"
      :text-cancel="textCancel"
      :text-confirm="textConfirm"
      @confirm="handleSurveyOrRequest"
      @cancel="cancelRequest"
    />

    <SurveyModal
      v-if="showSurveyModal"
      :survey="activeSurvey"
      :current-question-index="currentQuestionIndex"
      :final-button-text="'Accéder au service'"
      @survey-completed="submitFinalRequest"
      @cancel-survey="cancelSurvey"
    />
  </div>
</template>

<script>
import { useToast } from 'vue-toast-notification';
import * as Sentry from '@sentry/vue';
import GenericModal from '../../Utils/GenericModal.vue';
import SurveyModal from '../../Survey/SurveyModal.vue';
import { RequestServiceAccess, fetchActiveSurvey } from '../../../services/api.js';

export default {
  name: 'RequestAccessModal',
  components: {
    GenericModal,
    SurveyModal,
  },
  props: {
    serviceId: {
      type: [String, Number],
      required: true,
    },
  },
  emits: ['access-request-validated', 'close-request-access-modal'],
  data() {
    return {
      modalTitle: 'Vous souhaitez avoir accès à ce service ?',
      modalContent:
        'Vous êtes sur le point d’activer ce service, nous vous invitons à bien prendre connaissance des conditions spécifiques liées à son utilisation...',
      textConfirm: 'Oui, je confirme',
      textCancel: 'Annuler',
      requestIsPending: false,
      showSurveyModal: false,
      activeSurvey: null,
      currentQuestionIndex: 0,
    };
  },
  methods: {
    async handleSurveyOrRequest() {
      try {
        const surveyResponse = await fetchActiveSurvey();
        if (surveyResponse?.data?.survey) {
          const { survey, answeredCount, isCompleted } = surveyResponse.data;
          if (!isCompleted) {
            this.activeSurvey = survey;
            this.currentQuestionIndex = answeredCount;
            this.showSurveyModal = true;
            return;
          }
        }
        this.submitFinalRequest();
      } catch (error) {
        Sentry.captureException(error);
        useToast().error('Erreur lors de la récupération du sondage.');
      }
    },

    async submitFinalRequest() {
      this.requestIsPending = true;
      try {
        const response = await RequestServiceAccess(this.serviceId);
        if (response?.data) {
          useToast().success('Accès au service activé avec succès !');
          this.$emit('access-request-validated');
        } else {
          useToast().error("Erreur lors de la demande d'accès.");
        }
      } catch (error) {
        Sentry.captureException(error);
        useToast().error('Erreur inattendue.');
      } finally {
        this.requestIsPending = false;
        this.$emit('close-request-access-modal');
      }
    },

    cancelSurvey() {
      this.showSurveyModal = false;
    },

    cancelRequest() {
      this.$emit('close-request-access-modal');
    },
  },
};
</script>

<style scoped></style>
